import Lenis from "lenis";

let lenis = null;

export const initLenis = () => {
    if (lenis) return lenis;
    lenis = new Lenis({
        autoRaf: true,
        duration: 1.15,
        smoothWheel: true,
    });
    return lenis;
};

export const getLenis = () => lenis;
